<app-confirm-deletion-dialog
    [bodyHtml]="dialogBody"
    [dialogCloseObject]="data.id"
	[confirmButtonLabel]="'Yes, Delete The Group'"
    [errorToastMessage]="'Error while deleting vehicle group'" />
